var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M16.5,13.25 L10.25,13.25 L10.25,17.0575868 C10.25,17.1680437 10.1604569,17.2575868 10.05,17.2575868 C10.0013608,17.2575868 9.95438852,17.2398619 9.91787442,17.2077295 L4.17061671,12.1501427 C4.08769518,12.0771718 4.07962864,11.9507959 4.15259959,11.8678744 C4.15821624,11.8614919 4.16423415,11.8554739 4.17061671,11.8498573 L9.91787442,6.79227051 C10.0007959,6.71929957 10.1271718,6.72736611 10.2001427,6.81028764 C10.2322751,6.84680174 10.25,6.89377403 10.25,6.94241322 L10.25,10.75 L18.8,10.75 C18.9104569,10.75 19,10.8395431 19,10.95 L19,13.05 L19,16.7986825 C19,16.9091395 18.9104569,16.9986825 18.8,16.9986825 L16.7,16.9986825 C16.5895431,16.9986825 16.5,16.9091395 16.5,16.7986825 L16.5,13.25 Z","id":"path-1"}));
}

BackArrow.defaultProps = {"width":"25px","height":"25px","viewBox":"0 0 25 25","version":"1.1"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
